<template>
    <div class="container" style="padding:20px ">
        <div class="headBox">
            <div class="headTitle">数据概况</div>
        </div>
        <div class=" listBox">
            <div class="listItem img1">
                <div class="titleBox">
                    <div class="label">
                        <span>总交易额（元）</span>
                    </div>
                    <div class="value">{{data1}}</div>
                </div>
            </div>
            <div class="listItem img2">
                <div class="titleBox">
                    <div class="label">
                        <span>今日交易额（元）</span>
                    </div>
                    <div class="value">{{data2}}</div>
                </div>
            </div>
            <div class="listItem img3">
                <div class="titleBox">
                    <div class="label">
                        <span>总成交单数（笔）</span>
                    </div>
                    <div class="value">{{data3}}</div>
                </div>
            </div>
            <div class="listItem img4" style="margin-right:30px">
                <div class="titleBox">
                    <div class="label">
                        <span>今日成交单数（笔）</span>
                    </div>
                    <div class="value">{{data4}}</div>
                </div>
            </div>
        </div>
        <div class="martop30 listBox">
            <div class="listItem img5" v-if="merchantNum==''">
                <div class="titleBox">
                    <div class="label">
                        <span>今日新增商户(个)</span>
                    </div>
                    <div class="value">{{dayValue.addStore}}</div>
                </div>
            </div>
            <div class="listItem img6">
                <div class="titleBox">
                    <div class="label">
                        <span>昨日交易额(元)</span>
                    </div>
                    <div class="value">{{toTwo(dayValue.yMoney)}}</div>
                </div>
            </div>
            <div class="listItem img7">
                <div class="titleBox">
                    <div class="label">
                        <span>同比昨日</span>
                    </div>
                    <div class="value">{{year(dayValue.percentage)}}%</div>
                </div>
                <el-tooltip effect="dark" content="今日、昨日同一时间点交易数据" placement="top">
                    <img src="@/assets/img/tips.png" class="tipsIcon">
                </el-tooltip>
            </div>
            <div class="listItem img8" v-if="merchantNum==''">
                <div class="titleBox">
                    <div class="label">
                        <span>今日活跃商户(个)</span>
                    </div>
                    <div class="value">{{dayValue.active}}</div>
                </div>
                <el-tooltip effect="dark" content="今日有一笔交易为活跃" placement="top">
                    <img src="@/assets/img/tips.png" class="tipsIcon">
                </el-tooltip>
            </div>
        </div>
        <!-- <div>
            <span style="font-size:40px" @click="creatQrCode()">生成二维码!!!!!!!!!!!!!!!!!!!!!</span>
             <span style="font-size:40px" @click="downLoad()">下载二维码!!!!!!!!!!!!!!!!!!!!!</span>
            <div id="qrcode" ref="qrCodeUrl" ></div>
        </div> -->
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2'
    import bus from '../components/common/bus';
    export default {
        name: 'dashboard',
        data() {
            return {
                data1: '',
                data2: '',
                data3: '',
                data4: '',
                dayValue:[],
                query: {
                    id: '',
                    auth: '',
                },
                name: localStorage.getItem('ms_username'),
                items: [{
                        icon: 'el-icon-lx-home',
                        index: 'dashboard',
                        title: '数据统计'
                    },
                    {
                        icon: 'el-icon-lx-cascades',
                        index: 'merchants-Manage',
                        title: '商户管理',
                    },
                    {
                        icon: 'el-icon-lx-copy',
                        index: 'order',
                        title: '交易明细'
                    },
                    {
                        icon: 'el-icon-lx-home',
                        index: 'add-Merchant',
                        title: '系统设置'
                    },
                    {
                        icon: 'el-icon-s-custom',
                        index: 'main-service-provider',
                        title: '主服务商'
                    },
                    {
                        icon: 'el-icon-user',
                        index: 'sub-service-provider',
                        title: '子服务商'
                    }
                ],
                item1: [{
                        icon: 'el-icon-lx-home',
                        index: 'dashboard',
                        title: '数据统计'
                    },
                    {
                        icon: 'el-icon-lx-home',
                        index: 'add-Merchant',
                        title: '商户设置'
                    },
                    {
                        icon: 'el-icon-lx-copy',
                        index: 'order',
                        title: '交易明细'
                    },
                    {
                        icon: 'el-icon-bell',
                        index: 'voice',
                        title: '语音播报'
                    }
                ],
                merchantNum:''
            };
        },

       
        created() {
            this.checkWeChatCode()
            this.query.id = sessionStorage.getItem('merchants_id') ? sessionStorage.getItem('merchants_id') : '',
                this.query.auth = sessionStorage.getItem('merchants_id') ? '2' : '1'
            this.merchantNum = sessionStorage.getItem('merchants_id') ? sessionStorage.getItem('merchants_id') : '';
            this.getData()
        },
        mounted(){
            this.getData();
        },
        methods: {
            getData() {
                let that = this
                let url = that.$apiUrl.order.getHome
                that.$post(url, that.$params(that.query)).then(res => {
                    if (res.data.code == 200) {
                        that.data1 = res.data.data.counttrade
                        that.data2 = res.data.data.todaytrade
                        that.data3 = res.data.data.countorder
                        that.data4 = res.data.data.todayorder

                    }
                }).catch(error => {

                    this.$message.error(error)
                })
                that.$get(`${that.$apiUrl.order.getSeltrades}?id=${this.merchantNum}`).then(res =>{
                    that.dayValue = res.data.data
                })
            },
            downLoad() {
                let myCanvas = document.getElementById('qrcode').getElementsByTagName('canvas');
                let a = document.createElement('a')
                a.href = myCanvas[0].toDataURL('image/png');
                a.download = '二维码';
                a.click()
                this.$message({
                    message: "正在进行下载保存",
                    type: 'success'
                })
            },
            checkWeChatCode() {

                if (sessionStorage.getItem('merchants_id')) {
                    this.$store.commit('setItem', this.item1)
                } else {
                    let code = this.getUrlCode('id')
                    if (code) {
                        sessionStorage.setItem('merchants_id', code)
                        this.$store.commit('setItem', this.item1)
                        // sessionStorage.setItem('Menu',this.item1)
                    } else {
                        this.$store.commit('setItem', this.items)
                    }
                    let mid = this.getUrlCode('mid')
                    if (mid) {
                        sessionStorage.setItem('mid', mid)

                    }

                }
            },
            getUrlCode(name) {
                return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location
                        .href) || [,
                        ''
                    ])[1]
                    .replace(/\+/g, '%20')) || null
            },
            changeDate() {
                const now = new Date().getTime();
                this.data.forEach((item, index) => {
                    const date = new Date(now - (6 - index) * 86400000);
                    item.name = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
                });
            },
            creatQrCode() {
                var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    text: 'https://ym.huayetech.cn/', // 需要转换为二维码的内容
                    width: 200,
                    height: 200,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                })
            },
        },
        computed: {
            role() {
                return this.name === 'admin' ? '超级管理员' : '普通用户';
            },
            year(){
                return function(val){
                    return parseInt(val);
                }
            },
            toTwo(){
                return function(val){
                    return Math.floor(val*100)/100
                }
            }
        },
    };
</script>


<style scoped>
    .listBox {
        display: flex;
    }

    .listItem {
        margin-right: 30px;
        width: calc((100%-90px)/4);
        height: 130px;
        float: left;
        color: #fff;
        border-radius: 5px;
        flex: 1;
        background-position: bottom right;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
    }

    .img1 {
        background-image: url(../assets/img/data-bg1.png);
    }

    .img2 {
        background-image: url(../assets/img/data-bg2.png);
    }

    .img3 {
        background-image: url(../assets/img/data-bg3.png);
    }

    .img4 {
        background-image: url(../assets/img/data-bg4.png);
    }

    .img5 {
        background-image: url(../assets/img/data-bg7.png);
    }

    .img6 {
        background-image: url(../assets/img/data-bg5.png);
    }

    .img7 {
        background-image: url(../assets/img/data-bg6.png);
    }

    .img8 {
        background-image: url(../assets/img/data-bg8.png);
    }

    .headBox {
        background-color: #f8f8f8;
        line-height: 20px;
        min-height: 40px;
        padding: 10px;
        margin-bottom: 10px;
        height: 40px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        font-size: 12px;
        position: relative;
    }

    .headTitle {
        border-left: 4px solid #409EFF;
        padding-left: 10px;
        line-height: 12px;
        position: absolute;
        height: 12px;
        left: 5px;
        top: 14px;
    }

    .titleBox {
        width: 60%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .value {
        white-space: nowrap;
        font-family: Arial, sans-serif;
        font-size: 26px;
        line-height: 40px;
    }

    .label {
        line-height: 30px;
        font-size: 14px;
        white-space: nowrap
    }

    .martop30 {
        margin-top: 30px;
    }

    .tipsIcon {
        position: absolute;
        top: 10px;
        right: 20px;
        width: 20px;
        height: 20px;
        cursor: pointer;
    }
</style>